import Reflux from 'reflux';
import AlgoliaSearch from 'algoliasearch';
import Revelr from 'configs';
import Tracker from 'tracker';
import SearchActions from 'actions/SearchActions';

export default class extends Reflux.Store {
    constructor() {
        super();

        this.client = AlgoliaSearch(Revelr.algolia_app, Revelr.algolia_key);
        this.index = this.client.initIndex('venues');
        this.tracker = new Tracker();

        this.listenables = SearchActions;
        this.state = {
            results: [],
            resultCount: 0,
            page: 0,
            pageCount: 0,
        };
    }

    onLoadResults(params) {
        const searchFields = {
            page: this.state.page,
            hitsPerPage: 20,
        };
        const filters = [];

        if (params.capacity.value !== null) {
            const capacityFilters = [];
            capacityFilters.push(`seated_capacity >= ${params.capacity.value}`);
            capacityFilters.push(`standing_capacity >= ${params.capacity.value}`);
            capacityFilters.push(`seated_dinner_capacity >= ${params.capacity.value}`);
            filters.push(`(${capacityFilters.join(' OR ')})`);
        }

        if (params.location.value !== null) {
            const mappedCoords = [];

            params.location.value.forEach(coords => {
                const c = [];
                coords.forEach(pair => {
                    c.push(pair.lat);
                    c.push(pair.lng);
                });

                mappedCoords.push(c);
            });

            searchFields.insidePolygon = mappedCoords;
        }

        if (params.eventType.value !== null) {
            filters.push(`event_types:'${params.eventType.value}'`);
        }

        if (params.venueType.value !== null && params.venueType.value !== 'Other') {
            filters.push(`venue_types:'${params.venueType.value}'`);
        }

        if (params.outdoorSpace.value) {
            filters.push('outdoor_space:TRUE');
        }

        if (params.inhouseAV.value) {
            filters.push('inhouse_av:TRUE');
        }

        if (params.inhouseTables.value) {
            filters.push('inhouse_tables:TRUE');
        }

        if (params.guestRooms.value) {
            filters.push('guest_rooms:TRUE');
        }

        if (params.catering.value !== null) {
            filters.push(`catering_requirement_label:'${params.catering.value}'`);
        }

        searchFields.filters = filters.join(' AND ');

        this.index.search(searchFields, (err, content) => {
            if (err) {
                this.tracker.logMessage('Search Error', err);
                this.setState({ results: [], resultCount: 0 });
            } else {
                let randomized = [...content.hits.filter(r => r.paying).sort(() => Math.random() - 0.5), ...content.hits.filter(r => !r.paying).sort(() => Math.random() - 0.5)];

                this.setState({
                    results: [...this.state.results, ...randomized],
                    resultCount: content.nbHits,
                    page: this.state.page + 1,
                    pageCount: content.nbPages,
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/stores/SearchStore.jsx